import "core-js/modules/es6.object.assign";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";
import { IconoirContext } from "./IconoirContext";

function SvgDbCheck(passedProps, svgRef) {
  var context = React.useContext(IconoirContext);

  var props = __assign(__assign({}, context), passedProps);

  return React.createElement("svg", __assign({
    width: "1.5em",
    height: "1.5em",
    strokeWidth: 1.5,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    ref: svgRef
  }, props), React.createElement("path", {
    d: "M14 19l3 3 5-5M4 6v6s0 3 7 3 7-3 7-3V6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M11 3c7 0 7 3 7 3s0 3-7 3-7-3-7-3 0-3 7-3zM11 21c-7 0-7-3-7-3v-6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = React.forwardRef(SvgDbCheck);
export default ForwardRef;